export default function Footer(){
    return <div id="footer" className="py-5 bg-ternary text-center text-white ">
       &copy; G Vairamuthu 2024
    </div>
}